import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import AppointmentByDate from '../AppointmentByDate/AppointmentByDate';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

const DashboardAppointments = () => {
    const [selectDate, setSelectedDate] = useState(new Date())
    const [appointments, setAppointments] = useState([])
    const handleDateChange = date =>{
        setSelectedDate(date);    
    }

    useEffect( () => {
        fetch('http://localhost:5000/AppointmentByDate', {
            method: 'POST',
            headers: {'content-type': 'application/json'},
            body: JSON.stringify({date: selectDate})
        })
        .then(res => res.json())
        .then(data =>{
            setAppointments(data);
        })
    }, [selectDate])

    return (
        <section style={{background: '#f4fdfb', height:'50vw'}}>
            <div className="ps-0 container-fluid row">
                <div className="col-md-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-md-5 d-flex justify-content-center align-items-center">
                    <Calendar className='border-0 shadow lh-lg'
                        onChange={handleDateChange}
                        value={new Date()}
                    />
                </div>
                <div className="col-md-5">
                    <AppointmentByDate appointments={appointments} date={selectDate}></AppointmentByDate>
                </div>
            </div>
        </section>
    );
};

export default DashboardAppointments;